import React, { useState, useEffect } from 'react';
import DataTable from 'react-data-table-component';
import { Button, Card, Col, Form, Row, Modal, Spinner, Badge } from 'react-bootstrap';

import { FaRegClock, FaUserCheck } from 'react-icons/fa';
import { BsTrash, BsPlusCircle, BsCheckCircleFill, BsExclamationTriangle, BsSave } from 'react-icons/bs';
import { MsgInformativo } from '../../../Utils/Toast/msgInformativo';
import RelojChecadorDataService from '../../../Services/Catalogos/RelojChecador';
import NominaServices from '../../../Services/Catalogos/Nomina'; 
import DTOClaveNomina from '../../../DTO/DTOClaveNomina';
import { DTOReporteChecadas } from './DTO/DTOReporteChecadas';
import { DTOGestionChecadasParams } from './DTO/DTOGestionChecadasParams';
import CatPermisos from '../../../Services/Catalogos/CatPermisos';
import { DTOPermiso } from '../CatPermisos/DTO/DTOPermiso';
import { Console } from 'node:console';

export interface DTOObservacionSemanal {
    Accion: string;
    NumEmpleado: string;
    FechaInicio: string;
    FechaFin: string;
    Observacion: string;
    IdUsuarioRegistro: number;
}

interface Props {
  empleadoFiltro?: string;
  fechaInicioFiltro?: string;
  fechaFinFiltro?: string;
  notaInicial?: string;
}

export default function GestionChecadasComponent({ empleadoFiltro, fechaInicioFiltro, fechaFinFiltro, notaInicial }: Props) {
  
  const [data, setData] = useState<DTOReporteChecadas[]>([]);
  const [filteredData, setFilteredData] = useState<DTOReporteChecadas[]>([]);
  const [clavesCatalogo, setClavesCatalogo] = useState<DTOClaveNomina[]>([]);
  const [claveSeleccionada, setClaveSeleccionada] = useState('');
  const [loadingAjuste, setLoadingAjuste] = useState(false);

  const [notaDiaria, setNotaDiaria] = useState(notaInicial || '');
  const [loadingNota, setLoadingNota] = useState(false);

  const [toastMsg, setToastMsg] = useState('');
  const [toastHeader, setToastHeader] = useState('');
  const [toastColor, setToastColor] = useState('');
  const [showToast, setShowToast] = useState(false);

  const [checkDate, setCheckDate] = useState('');
  const [checkTime, setCheckTime] = useState('');
  const [showEditModal, setShowEditModal] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const [modalData, setModalData] = useState<any>({ userId: 0 });

  const usuarioIdEdicion = parseInt(localStorage.getItem('UserId')?.replace(/"/g, '') || "0");
   const [permisosOriginales, setPermisosOriginales] = useState<DTOPermiso[]>([]);
   const [evidenciasPermiso, setEvidenciasPermiso] = useState<any[]>([]);

  const mostrarToast = (msg: string, header: string, color: string) => {
    setToastMsg(msg); setToastHeader(header); setToastColor(color); setShowToast(true);
  };




  
     

      const cargarPermisosDelDia = () => {
          if (!empleadoFiltro || !fechaInicioFiltro) return;

          CatPermisos.GetPermisosPorEmpleado(empleadoFiltro)
              .then(res => {
                  const fechaGestion = fechaInicioFiltro.split('T')[0];
                  const filtrados = res.data.filter(p => p.fechaPermiso.split('T')[0] === fechaGestion);
                  setPermisosOriginales(filtrados);
              })
              .catch(err => console.error("Error al cargar permisos de origen", err));
      };


      const obtenerEvidenciasDelDia = async () => {
        if (!empleadoFiltro || !fechaInicioFiltro) return;
        
        const fechaLimpia = fechaInicioFiltro.split('T')[0];
        
        try {
            const res = await NominaServices.listarAdjuntos(empleadoFiltro, fechaLimpia);
            // setEvidenciasPermiso(res.data || []);
            const soloPermisos = res.data.filter((a: any) => a.tipoAdjunto === 'PPA' || a.tipoAdjunto === 'PSS');
                setEvidenciasPermiso(soloPermisos);
        } catch (err) {
            console.error("Error al obtener evidencias:", err);
        }
    };

      

      










      useEffect(() => {
          if (empleadoFiltro && fechaInicioFiltro) {
              setNotaDiaria(notaInicial || '');
              setCheckDate(fechaInicioFiltro); 
              buscarDatos();
              NominaServices.GetCatClavesNomina().then(res => setClavesCatalogo(res.data));
              cargarPermisosDelDia();
              obtenerEvidenciasDelDia(); 
          }
      }, [empleadoFiltro, fechaInicioFiltro, notaInicial]);
        


        const handleAjusteTecnicoPermiso = (idPermiso: number, campo: string, valor: any) => {
    const permiso = permisosOriginales.find(p => p.id === idPermiso);
    if (!permiso) return;

    // Preparamos el objeto con el campo IdUsuarioRegistro que pide el DTO de C#
    const payload: any = {
        ...permiso,
        [campo]: valor,
        IdUsuarioRegistro: usuarioIdEdicion
    };

    CatPermisos.EditarPermisoNomina(payload)
        .then(() => {
            mostrarToast("Horario de permiso de origen actualizado", "Ajuste Técnico", "info");
            cargarPermisosDelDia(); // Refrescamos la mini-lista
            buscarDatos(); // Refrescamos las checadas para que el SP de reporte se recalcule al cerrar
        })
        .catch(() => mostrarToast("Error al actualizar permiso", "Error", "danger"));
};























  const buscarDatos = () => {
    // Se consultan datos usando las fechas que vienen por props (el día seleccionado)
    RelojChecadorDataService.getReporteChecadas(fechaInicioFiltro!, fechaFinFiltro!)
      .then((response) => {
        setData(response.data);
        if (empleadoFiltro) {
          setFilteredData(response.data.filter((i: any) => i.numeroEmpleado === empleadoFiltro));
        } else {
          setFilteredData(response.data);
        }
      })
      .catch(() => mostrarToast('Error al cargar datos', 'Error', 'danger'));
  };

  // EFECTO CRÍTICO: Refresca el contenido cuando cambias de celda/día en la matriz
  useEffect(() => {
    if (empleadoFiltro && fechaInicioFiltro) {
        setNotaDiaria(notaInicial || '');
        setCheckDate(fechaInicioFiltro); 
        buscarDatos();
        NominaServices.GetCatClavesNomina().then(res => setClavesCatalogo(res.data));
    }
  }, [empleadoFiltro, fechaInicioFiltro, notaInicial]);



  



  const handleGuardarNota = (accion: 'GUARDAR' | 'ELIMINAR') => {
    setLoadingNota(true);
    const payload: DTOObservacionSemanal = {
        Accion: accion,
        NumEmpleado: empleadoFiltro || "",
        FechaInicio: fechaInicioFiltro || "",
        FechaFin: fechaFinFiltro || "",
        Observacion: accion === 'GUARDAR' ? notaDiaria : '',
        IdUsuarioRegistro: usuarioIdEdicion
    };

    NominaServices.MantenimientoObservacionSemanal(payload).then(() => {
        mostrarToast(accion === 'GUARDAR' ? 'Nota guardada' : 'Nota eliminada', 'Éxito', 'success');
        setLoadingNota(false);
    }).catch(() => setLoadingNota(false));
  };

 





const [hrsExtra, setHrsExtra] = useState<number>(0);
const [minExtra, setMinExtra] = useState<number>(0);


// const esAjusteTiempo = claveSeleccionada === 'HE2' || claveSeleccionada === 'HE3' || claveSeleccionada === 'PSS';
const esAjusteTiempo = claveSeleccionada === 'HE2' || claveSeleccionada === 'HE3'  ;







const handleGuardarAjusteManual = () => {
    if (!claveSeleccionada) return;
    setLoadingAjuste(true);
    
    // Identificamos si la clave requiere captura de tiempo (HE o PSS)
    const requiereTiempo = claveSeleccionada === 'HE2' || claveSeleccionada === 'HE3' || claveSeleccionada === 'PSS';
    
    let totalMinutos = requiereTiempo ? (hrsExtra * 60) + minExtra : 0;

    // LÓGICA DE RESTA: Si es PSS, forzamos que el número sea negativo para que SQL lo reste
    if (claveSeleccionada === 'PSS') {
        totalMinutos = -Math.abs(totalMinutos);
    }

    NominaServices.MantenimientoAjusteManual({
        numEmpleado: empleadoFiltro,
        fecha: fechaInicioFiltro,
        claveNomina: claveSeleccionada,
        minutosExtra: totalMinutos, 
        idUsuarioRegistro: usuarioIdEdicion
    }).then(() => {
        mostrarToast(
            claveSeleccionada === 'PSS' ? "Descuento aplicado" : "Ajuste guardado", 
            "Éxito", 
            "success"
        );
        setLoadingAjuste(false);
        setHrsExtra(0); 
        setMinExtra(0);
        buscarDatos();
    }).catch(() => setLoadingAjuste(false));
};




const handleEliminarAjusteDia = () => {
    setLoadingAjuste(true);
    
    NominaServices.MantenimientoAjusteManual({
        numEmpleado: empleadoFiltro,
        fecha: fechaInicioFiltro,
        // Si el switch está APAGADO, mandamos null para que el SP use EsRango = 0
        // fechaFin: aplicarARango ? fechaFinFiltro : null, 
        claveNomina: '', 
        minutosExtra: 0,
        idUsuarioRegistro: usuarioIdEdicion
    }).then(() => {
        // mostrarToast(aplicarARango ? "Rango eliminado" : "Registro eliminado", "Éxito", "success");
        // setLoadingAjuste(false);
         mostrarToast("Incidencias manuales eliminadas", "Éxito", "success");
        setLoadingAjuste(false);
        setClaveSeleccionada('');
        buscarDatos();
    }).catch(() => setLoadingAjuste(false));
};



  




  
  const handleEditChecada = () => {
  const params: DTOGestionChecadasParams = {
    Accion: 'EDITAR',
    userId: modalData.userId,
    numeroEmpleado: empleadoFiltro ?? "",
    checkTimeOriginal: modalData.checkTime!,
    checkTimeNuevo: `${checkDate}T${checkTime}:00`,
    // Ahora usamos el valor que el usuario seleccionó en el modal
    checkTypeNuevo: modalData.tipo === 'entrada' ? 'I' : 'O', 
    usuarioIdEdicion,
  };
  RelojChecadorDataService.gestionarChecada(params).then(() => {
       buscarDatos(); mostrarToast('Cambio guardado', 'Éxito', 'success'); setShowEditModal(false);
     }).catch(() => mostrarToast('Error al guardar', 'Error', 'danger'));


     console.log(params)
};

 





  const handleAddChecada = () => {
    const params: DTOGestionChecadasParams = {
      Accion: 'AGREGAR',
      userId: modalData.userId,
      numeroEmpleado: empleadoFiltro ?? "", 
      checkTimeNuevo: `${checkDate}T${checkTime}:00`,
      checkTypeNuevo: modalData.tipo === 'entrada' ? 'I' : 'O',
      usuarioIdEdicion,
    };
    RelojChecadorDataService.agregarChecada(params).then(() => {
      buscarDatos(); mostrarToast('Agregado correctamente', 'Éxito', 'success'); setShowAddModal(false);
    }).catch(() => mostrarToast('Error al agregar', 'Error', 'danger'));

    console.log(params)
  };

  const handleDeleteChecada = () => {
    if (!modalData.checkTime) return;
    const params: DTOGestionChecadasParams = {
      Accion: 'ELIMINAR',
      userId: modalData.userId,
      numeroEmpleado: empleadoFiltro ?? "", 
      checkTimeOriginal: modalData.checkTime, 
      usuarioIdEdicion: usuarioIdEdicion,
    };
    RelojChecadorDataService.eliminarChecada(params).then(() => {
        buscarDatos(); mostrarToast('Checada eliminada', 'Éxito', 'success'); setShowDeleteModal(false);
    });

    console.log(params)
  };

  const columns = [

    { name: 'Fecha', selector: (row: DTOReporteChecadas) => row.fecha, width: '110px' },
    ...[1, 2, 3].flatMap(n => [
      {
        name: `E${n}`,
        cell: (row: any) => {
          const val = row[`entrada${n}`];
          return val ? (
            <div className="d-flex align-items-center">
              {val.split('T')[1].slice(0,5)}
              <span onClick={() => { setModalData({ userId: row.userId, fecha: row.fecha, tipo: 'entrada', numero: n, checkTime: val }); setCheckDate(val.split('T')[0]); setCheckTime(val.split('T')[1].substring(0, 5)); setShowEditModal(true); }} style={{ cursor: 'pointer', marginLeft: '6px' }}>✏️</span>
              <span onClick={() => { setModalData({ userId: row.userId, fecha: row.fecha, tipo: 'entrada', numero: n, checkTime: val }); setShowDeleteModal(true); }} style={{ cursor: 'pointer', marginLeft: '6px', color: 'red' }}><BsTrash /></span>
            </div>
          ) : (
            // <BsPlusCircle style={{ color: 'green', cursor: 'pointer' }} onClick={() => { setModalData({ userId: row.userId, fecha: row.fecha, tipo: 'entrada', numero: n }); setCheckDate(row.fecha); setCheckTime("08:00"); setShowAddModal(true); }} />
            <BsPlusCircle 
                style={{ color: 'green', cursor: 'pointer' }} 
                onClick={() => { 
                    setModalData({ 
                        userId: row.userId, 
                        fecha: row.fecha, 
                        tipo: 'entrada',
                        numero: n 
                    }); 
                    
                    // Limpiamos la fecha por si trae una "T" o espacio
                    const fechaLimpia = row.fecha.split('T')[0].split(' ')[0];
                    setCheckDate(fechaLimpia); 
                    
                    setCheckTime("08:00"); 
                    setShowAddModal(true); 
                }} 
            />

          )
        }
      },
      {
        name: `S${n}`,
        cell: (row: any) => {
          const val = row[`salida${n}`];
          return val ? (
            <div className="d-flex align-items-center">
              {val.split('T')[1].slice(0,5)}
              <span onClick={() => { setModalData({ userId: row.userId, fecha: row.fecha, tipo: 'salida', numero: n, checkTime: val }); setCheckDate(val.split('T')[0]); setCheckTime(val.split('T')[1].substring(0, 5)); setShowEditModal(true); }} style={{ cursor: 'pointer', marginLeft: '6px' }}>✏️</span>
              <span onClick={() => { setModalData({ userId: row.userId, fecha: row.fecha, tipo: 'salida', numero: n, checkTime: val }); setShowDeleteModal(true); }} style={{ cursor: 'pointer', marginLeft: '6px', color: 'red' }}><BsTrash /></span>
            </div>
          ) : (
            // <BsPlusCircle style={{ color: 'green', cursor: 'pointer' }} onClick={() => { setModalData({ userId: row.userId, fecha: row.fecha, tipo: 'salida', numero: n }); setCheckDate(row.fecha); setCheckTime("18:00"); setShowAddModal(true); }} />

            <BsPlusCircle 
        style={{ color: 'green', cursor: 'pointer' }} 
        onClick={() => { 
            setModalData({ 
                userId: row.userId, 
                fecha: row.fecha, 
                tipo: 'salida',
                numero: n 
            }); 
            
            // Sanitización de fecha
            const fechaLimpia = row.fecha.split('T')[0].split(' ')[0];
            setCheckDate(fechaLimpia); 
            
            setCheckTime("18:00"); // Hora sugerida de salida
            setShowAddModal(true); 
        }} 
      />
          )
        }
      }
    ]),
    // { name: 'Total', selector: (row: DTOReporteChecadas) => row.totalHoras || '', width: '80px' }
  ];


 




  return (
    <div>
      <Card className="mb-3 border-warning shadow-sm">
        
      <Card.Header className="bg-warning py-1 fw-bold small">Ajuste de Incidencia</Card.Header>
        

<Card.Body className="py-2 px-3">
    <Row className="align-items-end g-2">
        {/* SELECTOR DE CLAVE */}
        <Col md={esAjusteTiempo ? 4 : 8}> 
            <Form.Label className="small mb-0 fw-bold">Clave:</Form.Label>
            <div className="d-flex gap-1">
                <Form.Select 
                    size="sm" 
                    value={claveSeleccionada} 
                    onChange={e => setClaveSeleccionada(e.target.value)}
                >
                    <option value="">-- Seleccionar --</option>
                    {/* {clavesCatalogo.map(c => (
                        <option key={c.idClave} value={c.clave}>
                            {c.clave} - {c.descripcion}
                        </option>
                    ))} */}

                    {clavesCatalogo
                    .filter(c => c.clave !== 'VAC')
                    .map(c => (
                        <option key={c.idClave} value={c.clave}>
                            {c.clave} - {c.descripcion}
                        </option>
                    ))
                }


                </Form.Select>
                <Button variant="outline-danger" size="sm" onClick={handleEliminarAjusteDia}>
                    <BsTrash />
                </Button>
            </div>
        </Col>

        
        


{esAjusteTiempo ? (
    <>
        {/* INPUTS PARA HORAS EXTRAS (HE2, HE3) */}
        <Col md={2}>
            <Form.Label className="small mb-0 fw-bold">Hrs:</Form.Label>
            <Form.Control 
                type="number" 
                size="sm" 
                value={hrsExtra} 
                onChange={e => setHrsExtra(parseInt(e.target.value) || 0)} 
            />
        </Col>
        <Col md={2}>
            <Form.Label className="small mb-0 fw-bold">Min:</Form.Label>
            <Form.Control 
                type="number" 
                size="sm" 
                max="59" 
                value={minExtra} 
                onChange={e => setMinExtra(parseInt(e.target.value) || 0)} 
            />
        </Col>
        <Col md={4}>
            <Button 
                variant="warning" 
                size="sm" 
                className="w-100 fw-bold" 
                onClick={handleGuardarAjusteManual}
            >
                {loadingAjuste ? <Spinner size="sm" /> : 'Aplicar'}
            </Button>
        </Col>
    </>
) : (
    /* BOTÓN PARA PSS, PPA, VAC, ETC. (Día completo sin cuadros de tiempo) */
    <Col md={4}>
        <Button 
            variant="warning" 
            size="sm" 
            className="w-100 fw-bold" 
            onClick={handleGuardarAjusteManual}
            disabled={!claveSeleccionada}
        >
            {loadingAjuste ? <Spinner size="sm" /> : 'Aplicar'}
        </Button>
    </Col>
)}




    </Row>
</Card.Body>
   





      </Card>


      

      <DataTable columns={columns} data={filteredData} dense striped highlightOnHover pagination />
      {filteredData.length === 0 && empleadoFiltro && fechaInicioFiltro && (
  <Card className="mt-3 border-success shadow-sm text-center">
    <Card.Body>
      <h6 className="mb-2">No hay checadas registradas este día</h6>

      <Button
        variant="success"
        size="sm"
        onClick={() => {
          setModalData({
            userId: 0,
            tipo: 'entrada'
          });

          const fechaLimpia = fechaInicioFiltro.split('T')[0];
          setCheckDate(fechaLimpia);
          setCheckTime("08:00");

          setShowAddModal(true);
        }}
      >
        <BsPlusCircle className="me-1"/> Registrar Entrada
      </Button>

      <Button
        variant="outline-primary"
        size="sm"
        className="ms-2"
        onClick={() => {
          setModalData({
            userId: 0,
            tipo: 'salida'
          });

          const fechaLimpia = fechaInicioFiltro.split('T')[0];
          setCheckDate(fechaLimpia);
          setCheckTime("18:00");

          setShowAddModal(true);
        }}
      >
        Registrar Salida
      </Button>

    </Card.Body>
  </Card>
)}

{/* --- SECCIÓN DE EDICIÓN TÉCNICA DE PERMISOS --- */}
{permisosOriginales.length > 0 && (
    <Card className="mb-3 border-info shadow-sm bg-light">
        <Card.Header className="bg-info text-white py-1 fw-bold small">
            <FaRegClock className="me-2"/> Edición de Horario de Permiso (Origen)
        </Card.Header>
        <Card.Body className="py-2">
            {permisosOriginales.map(p => (
                <div key={p.id} className="border-bottom mb-2 pb-2">
                    <Row className="g-2 align-items-end">
                        <Col md={4}>
                            <div className="small fw-bold text-primary">{p.motivo}</div>
                            <Badge bg={p.estado === 'Aceptado' ? 'success' : 'warning'} style={{fontSize: 8}}>
                                {p.estado}
                            </Badge>
                        </Col>
                        <Col md={2}>
                            <Form.Label className="small mb-0">Salida:</Form.Label>
                            <Form.Control 
                                size="sm" type="time" 
                                defaultValue={p.horaInicio} 
                                onBlur={(e) => handleAjusteTecnicoPermiso(p.id, 'horaInicio', e.target.value)}
                            />
                        </Col>
                        <Col md={2}>
                            <Form.Label className="small mb-0">Regreso:</Form.Label>
                            <Form.Control 
                                size="sm" type="time" 
                                defaultValue={p.horaFin} 
                                onBlur={(e) => handleAjusteTecnicoPermiso(p.id, 'horaFin', e.target.value)}
                            />
                        </Col>
                        <Col md={4}>
                            <Form.Check 
                                type="switch"
                                label="Día Completo"
                                className="small mt-3"
                                defaultChecked={p.esDiaCompleto}
                                onChange={(e) => handleAjusteTecnicoPermiso(p.id, 'esDiaCompleto', e.target.checked)}
                            />
                        </Col>
                    </Row>

                    {/* --- SECCIÓN DE EVIDENCIAS DENTRO DEL CUADRO AZUL --- */}
<Col md={12} className="mt-2 pt-2 border-top">
    <div className="d-flex flex-wrap align-items-center gap-2">
        <span className="small fw-bold text-muted" style={{fontSize: '11px'}}>Documentos:</span>
        {evidenciasPermiso.length === 0 ? (
            <span className="text-muted small italic" style={{fontSize: '10px'}}>Sin adjuntos</span>
        ) : (
            evidenciasPermiso.map(adj => (
                <Button 
                    key={adj.id}
                    variant="outline-primary" 
                    size="sm" 
                    style={{fontSize: '10px', padding: '1px 6px'}}
                    onClick={() => NominaServices.verAdjuntoEnNuevaPestana(adj.id)}
                >
                    👁️ Ver {adj.nombreOriginal.length > 15 ? 'Doc' : adj.nombreOriginal}
                </Button>
            ))
        )}
    </div>
</Col>
                </div>
            ))}
            <div className="text-muted" style={{ fontSize: '9px' }}>
                * Esta edición modifica el permiso original del sistema y recalcula automáticamente los descuentos.
            </div>
        </Card.Body>
    </Card>
)}












      <Card className="mt-3 border-primary shadow-sm">
        <Card.Header className="bg-primary text-white fw-bold py-1 small">Nota Diaria</Card.Header>
        <Card.Body className="py-2">
            <Form.Control as="textarea" rows={3} size="sm" value={notaDiaria} onChange={e => setNotaDiaria(e.target.value)} placeholder="Justificación diaria..." />
            <div className="d-flex gap-2 mt-2">
                <Button variant="primary" size="sm" className="w-100 fw-bold" disabled={loadingNota} onClick={() => handleGuardarNota('GUARDAR')}>
                    {loadingNota ? <Spinner size="sm" /> : <><BsSave className="me-1"/> Guardar Nota</>}
                </Button>
                <Button variant="outline-danger" size="sm" onClick={() => handleGuardarNota('ELIMINAR')}><BsTrash /></Button>
            </div>
        </Card.Body>
      </Card>

      

      <Modal show={showEditModal} onHide={() => setShowEditModal(false)} centered>
  <Modal.Header closeButton><Modal.Title className="small">Editar Registro</Modal.Title></Modal.Header>
  <Modal.Body>
      <Row>
          <Col md={4}>
              <Form.Label className="small">Tipo</Form.Label>
              <Form.Select 
                  size="sm" 
                  value={modalData.tipo === 'entrada' ? 'I' : 'O'} 
                  onChange={e => setModalData({...modalData, tipo: e.target.value === 'I' ? 'entrada' : 'salida'})}
              >
                  <option value="I">Entrada</option>
                  <option value="O">Salida</option>
              </Form.Select>
          </Col>
          <Col md={4}><Form.Label className="small">Fecha</Form.Label><Form.Control size="sm" type="date" value={checkDate} onChange={e => setCheckDate(e.target.value)} /></Col>
          <Col md={4}><Form.Label className="small">Hora</Form.Label><Form.Control size="sm" type="time" value={checkTime} onChange={e => setCheckTime(e.target.value)} /></Col>
      </Row>
  </Modal.Body>
  <Modal.Footer><Button size="sm" onClick={handleEditChecada}>Guardar</Button></Modal.Footer>
</Modal>

      <Modal show={showAddModal} onHide={() => setShowAddModal(false)} centered>
        <Modal.Header closeButton><Modal.Title className="small">Nueva Checada</Modal.Title></Modal.Header>
        <Modal.Body>
            <Row><Col md={6}><Form.Label className="small">Fecha</Form.Label><Form.Control size="sm" type="date" value={checkDate} onChange={e => setCheckDate(e.target.value)} /></Col>
            <Col md={6}><Form.Label className="small">Hora</Form.Label><Form.Control size="sm" type="time" value={checkTime} onChange={e => setCheckTime(e.target.value)} /></Col></Row>
        </Modal.Body>
        <Modal.Footer><Button size="sm" variant="success" onClick={handleAddChecada}>Registrar</Button></Modal.Footer>
      </Modal>

      <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} centered>
        <Modal.Header closeButton><Modal.Title className="small text-danger">Eliminar Registro</Modal.Title></Modal.Header>
        <Modal.Body className="small text-center">¿Confirmas la eliminación?</Modal.Body>
        <Modal.Footer><Button size="sm" variant="secondary" onClick={() => setShowDeleteModal(false)}>Cancelar</Button><Button size="sm" variant="danger" onClick={handleDeleteChecada}>Confirmar</Button></Modal.Footer>
      </Modal>

      <MsgInformativo show={showToast} msg={toastMsg} header={toastHeader} msgColor={toastColor} closeToast={() => setShowToast(false)} />
    </div>
  );
}

